import React, { useContext, useEffect, useRef, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { GetFootballConfig, GetRaceConfig, GetBetslipConfig } from '../Common/ConfigHelper';
import { IsPassBetlinesValidFn } from './BetlinesValidFunc';
import { GlobalContext } from '../../contexts/GlobalContext';
import { GetChannelPara, IsBetTypeEnabled, IsFlexibetEnabled } from '../Common/ChannelParaFunc';
import { saveBetLinesToCurrentSessionRecords } from '../Common/CurrentSessionRecords';
import { AddToSlipAnimationFn } from '../Common/ui-components/AddToSlipAnimation';
import { useWindowSize, useShowAlertDialog } from '../Common/CommonHooks';
import { getSessionId_IB, getBalance_IB, sendBetApi_IB } from './BetSlipIBAPI';
import * as LoginIBHookObj from '../BetSlip/LoginIBHooks';
import { isLogonHigh } from '../BetSlip/LoginHooks';
import { isEoD } from '../Common/GlobalFunc';
import { checkPreviewBetOddsUpdated } from './useBetSlipPush/common';
import { clearBetLineOddsUpdTs } from '../Common/utils';
import { useAdobeLaunch } from '../Common/utils/adobeLaunch';
import { getAddToBetSlipAdobeEventData, getDeleteBetSlipAdobeEventData, getTransactionBetResultAdobeEventData } from '../Common/utils/eCommerceEvent';
import { getXtremePushData } from '../../components/Common/utils/xtremepush/xtremepushFunc';
const { GetLoginStatus } = LoginIBHookObj;


const clearCounterOfferData = (betLine) => {
    const result = {
        ...betLine,
        counterOfferAmountChange: undefined,
        counterOfferOddsChange: undefined,
        isCounterOffer: undefined,
    };
    if (result.counterOfferData) {
        delete result['counterOfferData'];
    }
    if (result['oldUnitBet']) {
        delete result['oldUnitBet'];
    }
    result.betObj?.combs?.map((comb) => {
        if (comb['oldOddsVal']) {
            delete comb['oldOddsVal'];
        }
    });
    result.betObj?.betList?.map((betList) => {
        betList.combs?.map((comb) => {
            if (comb['oldOddsVal']) {
                delete comb['oldOddsVal'];
            }
        });
    });
    return result;
};

export const MyBetSlipContext = React.createContext([]);

export const getBalanceValue = async (isOpener = false) => {
    const accessToken = window.sessionStorage.getItem('access_token') || '';

    const data = await getBalance_IB(isOpener);

    if (data?.balance != null && data?.balance != '') {
        sessionStorage.setItem('balance', data?.balance);
    }
    return data;

};

export const useBetSlip = () => {
    const {
        betBaskets,
        setBetBaskets,
        currentBasket,
        setCurrentBasket,
        balance,
        setBalance,
        isSpeedbet,
        setIsSpeedbet,
        betBaskets_0,
        xtremePush,
        mobileAlertObj,
        firstTimeFromJCRWRedirect
    } = useContext(MyBetSlipContext);
    const globalContext = useContext(GlobalContext);
    const { t, i18n } = useTranslation();
    const { isMobileSize } = useWindowSize();
    const [panelAllupArr, setPanelAllupArr] = useState([]);
    const panelAllupRef = useRef()
    panelAllupRef.current = panelAllupArr;
    const [isShowPreviewInfo, setIsShowPreviewInfo] = useState(false);
    const [isShowConfirmation, setIsShowConfirmation] = useState(false);
    const [confirmationStatus, setConfirmationStatus] = useState({
        status: null,
        isResendBet: false,
        accepted: 0,
        rejected: 0,
        unknown: 0
    });
    const [isShowFTInplayDialog, setIsShowFTInplayDialog] = useState(false);
    const speedbetBasket = window.globalConfig.SPEEDBET_BASKET;
    const [betTotal, setBetTotal] = useState();
    const [isShowError, setIsShowError] = useState(false);
    const showErrorRef = useRef();
    const [sendBetTime, setSendBetTime] = useState(null);
    const [panelAllupData, setPanelAllupData] = useState({
        unitBet: 10,
        noOfComb: '-',
        dividend: '-',
        netReturn: '-',
        alupFormula: ''
    });
    const FBConfig = GetFootballConfig();
    const HRConfig = GetRaceConfig();
    const { getAlertShowMode, closeAlertFunc } = useShowAlertDialog();
    const updateBetSlipOnUserStateChangeRef = useRef();
    const { sendAdobeEvent } = useAdobeLaunch();

    const [disablePreviewConfirm,setDisablePreviewConfirm] = useState(false)

    useEffect(() => {
        let initAllupArr = [];
        speedbetBasket.map((item) => {
            let obj = {
                name: item,
                allupType: '',
                subTypeList: [],
                allupMaxLeg: 8,
                allupGroup: 1,
                uniqueMatchIdList: [],
                allupCheckList: []
            };
            initAllupArr.push(obj);
        });
        setPanelAllupArr(initAllupArr);
    }, []);

    useEffect(() => {
        if (isShowError) {
            clearInterval(showErrorRef.current);
            showErrorRef.current = setTimeout(() => {
                setIsShowError(false);
            }, 3000);
        }
        return () => {
            clearInterval(showErrorRef.current);
        };
    }, [isShowError]);

    /**
     *
     * @param {Array<Object>} newBetlines bet lines
     */

     const addToBetSlip = (newBetlines, needDelBetList = [], source) => {
        if(sessionStorage.getItem('confirmationStatus') === 'accepted') {
            const betslip_finish_button = document.getElementById("betslip_finish_button")
            if(betslip_finish_button) {
                betslip_finish_button?.click()
                betBaskets[currentBasket] = betBaskets[currentBasket].filter((i) =>  i.betObj.sellStatus == 'SUSPENDED' )
            } else {
                sessionStorage.removeItem('confirmationStatus')
            }
        }
        let betSlipInfo = {
            acceptResult: false,
            acceptType: 'all',  // all, part
            acceptBetSlipLength: GetBetslipConfig()?.maxBetlines,
        }
        if (mobileAlertObj?.isShow && sessionStorage.getItem('betshareSourcePopup') != 1) {
            return betSlipInfo;  
        }
        if (sessionStorage.getItem('betshareSourcePopup')) {
            sessionStorage.removeItem('betshareSourcePopup');
        }
        if (!GetBetslipConfig()) return betSlipInfo;
        if (isEoD()) return betSlipInfo; //check is not EoD
        const { betslipState } = globalContext.globalState;
        if (betslipState != 0 && betslipState != 3) { // 3 handle below 
            if (betslipState == 1) {
                getAlertShowMode(t('LB_BS_ADDTOSLIP_IS_EKBA'));
            } else if (betslipState == 3) {
                getAlertShowMode(t('LB_BS_ADDTOSLIP_IS_BETTING'));
            } else {
                getAlertShowMode(t('LB_BS_ADDTOSLIP_IS_OTINACTIVE'));
            }
            return betSlipInfo;
        } else if (betslipState == 3 && sessionStorage.getItem('confirmationStatus') !== 'accepted') {
            getAlertShowMode(t('LB_BS_ADDTOSLIP_IS_BETTING'));
            return betSlipInfo;
        }

        if (GetLoginStatus?.()?.isBusy) {
            getAlertShowMode(t('LB_BS_ADDTOSLIP_BUSY'));
            return betSlipInfo;
        }
        let hasMaxiMumTips = false;
        let newData = [...betBaskets[currentBasket]];
        let betshareReset = false;
         if (sessionStorage.getItem('betshareReset') == 1) {
            console.log('betslip add clear array');
            betshareReset = true;
            newData= []
            sessionStorage.removeItem('betshareReset')
        }
        const MAX_SIZE = 3 * 1024 * 1024; // betBaskets cannot exceed 3MB
        
        const betStr = JSON.stringify([...newData,...newBetlines]);
        const betStrSize = new Blob([betStr]).size

        if (newData.length + newBetlines.length > GetBetslipConfig()?.maxBetlines || betStrSize > MAX_SIZE) {
            getAlertShowMode(t('LB_BS_ADDTOSLIP_MAXIMUM'));
            hasMaxiMumTips = true;
            if (newData.length >= GetBetslipConfig()?.maxBetlines) {
                return betSlipInfo;
            }
        }

        if (!newBetlines?.length) return betSlipInfo;

        const canAddBetLength = GetBetslipConfig()?.maxBetlines - newData.length;
        const paramBetLength = newBetlines.length;
        if (newBetlines.length - canAddBetLength > 0) {
            newBetlines = newBetlines.slice(0, canAddBetLength);
        }
        let isParaEnabled = true;
        let isFlexiEnabled = true;
        let isUnitBetValid = true;
        newBetlines.forEach((line) => {
            if (!isBetLineEnabledParaCheck(line)) {
                isParaEnabled = false;
                return;
            }

            if (line.isFlexi && !IsFlexibetEnabled(line.betType)) {
                isFlexiEnabled = false;
                return;
            }

            if (line.unitBet > Number(GetChannelPara('MaxBetUnit'))) {
                isUnitBetValid = false;
                return;
            }

            if (betBaskets[currentBasket].find((item) => item.id === line.id && (item.prod === 'FB' || item.isJKCTNC === true))) {
                return false
            };
            let showAllUpCheckBox = false;

            if (IsAllUpEnabled(line.prod) && isAllUpEnabledWithBetType(line.betType)) {
                showAllUpCheckBox = true;
            }
            const newBetSlipItem = {
                betObj: line,
                id: line.id,
                prod: line.prod,
                showAllUpCheckBox,
                allUpChecked: false,
                isExpended: false,
                isCounterOffer: false,
                isAutoAcceptance: false,
                unitBet: line.unitBet || 10,
                source
            };
            if (newBetSlipItem.prod === 'HR') {
                newBetSlipItem.betObj.meetingDate = line.meetingDate || globalContext?.RacingContextRef?.current?.meeting?.date;
            }
            newData = [...newData, newBetSlipItem];
        });
        if (needDelBetList.length > 0) {
            newData = newData.filter((item) => !needDelBetList.includes(item.id));
        }
        if (!isParaEnabled) {
            getAlertShowMode(t('LB_BS_ADDTOSLIP_ERR_NOT_AVAILABLE'));
            return betSlipInfo;
        }

        if (!isFlexiEnabled) {
            getAlertShowMode(t('LB_BS_ADDTOSLIP_ERR_NO_FLEXI'));
            return betSlipInfo;
        }

        if (!isUnitBetValid) {
            getAlertShowMode(t('LB_BS_ADDTOSLIP_ERR_EXCEE_AMT'));
            return betSlipInfo;
        }
        const betlinesValidResult = IsPassBetlinesValidFn(newData);
        let passValidBets = betlinesValidResult.passBets;
        if (betlinesValidResult.passBetlineChar > GetBetslipConfig()?.maxBetlineChar) {
            !hasMaxiMumTips && getAlertShowMode(t('LB_BS_ADDTOSLIP_MAXIMUM'));
            const verifyMaxCharResult = verifyMaxChar(newData, GetBetslipConfig().maxBetlineChar, canAddBetLength);
            newData = verifyMaxCharResult.list;
            passValidBets = verifyMaxCharResult.passBetlines;
        }
        betSlipInfo.acceptBetSlipLength = betshareReset ? 1 : newData.length - betBaskets[currentBasket].length;
        if (betSlipInfo.acceptBetSlipLength == 0 && sessionStorage.getItem('confirmationStatus') !== 'accepted') {

            return betSlipInfo
        } else if (betSlipInfo.acceptBetSlipLength != paramBetLength) {
            betSlipInfo.acceptType = 'part'
        }
        betSlipInfo.acceptResult = true;
        const isOpenBetslipPanel = document.querySelector('#divBetSlipNormal')?.offsetWidth > 0;
        if (isMobileSize && !isOpenBetslipPanel) {
            setTimeout(() => {
                AddToSlipAnimationFn(newBetlines.length, () => {
                    globalContext?.setIsWaitMobileFootballAllupCal?.(false);
                });
            }, 100);
        }
        const addToBetSlipAdobeEventData = getAddToBetSlipAdobeEventData({
            newBets: newData,
            passValidBets,
            acceptBetSlipLength: betSlipInfo.acceptBetSlipLength,
            source
        }, t, i18n);
        if (addToBetSlipAdobeEventData) {
            sendAdobeEvent(addToBetSlipAdobeEventData);
        }
        updateCurrentBasket(newData);
        sessionStorage.removeItem('confirmationStatus')
        return betSlipInfo;
    };

    const verifyMaxChar = (list, maxChar, num) => {
        if (num == 0) {
            return {
                list,
                passBetlines: []
            };
        }
        const validResult = IsPassBetlinesValidFn(list);
        if (validResult.passBetlineChar > maxChar) {
            const newList = list.slice(0, -1);
            return verifyMaxChar(newList, maxChar, num - 1)
        } else {
            return {
                list,
                passBetlines: validResult.passBets
            };
        }
    }

    const updateResendBetLine = (newData) => {
        let currentBasketData = [...betBaskets[currentBasket]].map((item) => {
            if (item.id === newData.id) {
                return newData;
            }
            return item;
        });
        updateCurrentBasket(currentBasketData);
    };

    const updateCurrentBasket = (newData) => {
        const baskets = [...betBaskets];
        baskets[currentBasket] = newData;
        setBetBaskets(baskets);
        // if (window.racingConfig["redirectIsReplaceWindow"]) {
        //     sessionStorage.setItem('betBaskets', compressToUTF16(JSON.stringify(baskets)));
        // }
        if (mobileAlertObj?.isShow) {
            closeAlertFunc();   
        }

        console.debug('baskets', baskets);
    };

    const clearBetSlip = () => {
        setCurrentBasket(0);
        const noOfBetslipTabs =
            isSpeedbet ? window.globalConfig.SPEEDBET_BASKET.length : 1;
        setBetBaskets(Array(Number(noOfBetslipTabs)).fill([]));
        resetPanelAllupFn('all');
    };

    const clearCurrentBasket = (option = {}) => {
        let newData = [];
        const currentBasketData = option.currentBasketData || betBaskets[currentBasket];
        let isResend = option.isResend
        let clearAll = option.clearAll
        if (isResend) {
            newData = currentBasketData.filter((i) => i.isCounterOffer || i.betObj.sellStatus == 'SUSPENDED' || i.onlyDisplayOnBetSlip );

            //clear old counter offer values
            newData.map((item) => {
                if (item['oldUnitBet']) {
                    delete item['oldUnitBet'];
                }
                item.betObj?.combs?.map((comb) => {
                    if (comb['oldOddsVal']) {
                        delete comb['oldOddsVal'];
                    }
                });
                item.betObj?.betList?.map((betList) => {
                    betList.combs?.map((comb) => {
                        if (comb['oldOddsVal']) {
                            delete comb['oldOddsVal'];
                        }
                    });
                });
            });
        }else if(!clearAll){
            newData = currentBasketData
                .filter((i) =>  i.betObj.sellStatus == 'SUSPENDED' || i.onlyDisplayOnBetSlip )
                .map((item) => {
                    if (item.prod !== 'FB') {
                        return item;
                    }
                    return {
                        ...clearBetLineOddsUpdTs(item),
                        onlyDisplayOnBetSlip: undefined
                    };
                });
        }

        updateCurrentBasket(newData);
        resetPanelAllupFn();
    };

    updateBetSlipOnUserStateChangeRef.current = () => {
        if (!window.globalConfig.RETAIN_BETS_IN_BET_SLIP_ON_LOGOUT) {
            clearBetSlip();
            return;
        }

        const currentBasketData = betBaskets[currentBasket];
        const noOfBetSlipTabs =
            isSpeedbet ? window.globalConfig.SPEEDBET_BASKET.length : 1;
        const newBetBaskets = Array(Number(noOfBetSlipTabs)).fill([]);
        const isPreviewPage = isShowPreviewInfo && !isShowConfirmation;
        if (currentBasketData && currentBasketData.length > 0) {
            if (isShowConfirmation) {
                newBetBaskets[0] = currentBasketData.filter(betItem => {
                    // filter out submitted, rejected, status unknown, closed

                    if (betItem.betObj.sellStatus == 'CLOSED') return false; // closed
                    if (betItem.prod === 'FB' && betItem.onlyDisplayOnBetSlip) return true; // only display on betSlip
                    if (betItem.betObj.sellStatus == 'SUSPENDED') return true; // suspend

                    if (
                        betItem.resultCode === 0 && !betItem.counterOfferData // submitted
                        || betItem.resultCode === 1 // rejected
                        || !betItem.isNotPlaced && !betItem.resultCode && betItem.resultCode !== 0 // unknown
                    ) {
                        return false;
                    }
                    return true;
                }).map(betItem => {
                    let result = {...betItem};
                    if (result.isNotPlaced) {
                        result = {
                            ...result,
                            isNotPlaced: undefined,
                            reason: undefined
                        }
                    }
                    if (betItem.counterOfferData) {
                        result = {
                            ...clearCounterOfferData(result),
                            resultCode: undefined,
                            txNo: undefined,
                            showResendControlBtn: undefined,
                            resultMsg: undefined,
                            resultMsgChi: undefined,
                            resultAmount: undefined,
                            flexiUnitBet: undefined
                        };
                    }
                    if (window.globalConfig.BS_PREVIEW_DATA_REFRESH) {
                        result = {
                            ...result,
                            isAcceptance: undefined,
                            isStopSellOnPreview: false,
                            onlyDisplayOnBetSlip: undefined
                        }
                    }

                    if (result.prod === 'FB') {
                        return clearBetLineOddsUpdTs(result);
                    }

                    return result;
                });
            } else if (isPreviewPage && window.globalConfig.BS_PREVIEW_DATA_REFRESH) {
                newBetBaskets[0] = currentBasketData.map(betItem => {
                    return {
                        ...betItem,
                        isAcceptance: undefined,
                        isStopSellOnPreview: false,
                        onlyDisplayOnBetSlip: undefined
                    }
                });
            } else {
                newBetBaskets[0] = currentBasketData;
            }
        }

        setCurrentBasket(0);
        setBetBaskets(newBetBaskets);
        // resetPanelAllupFn('all');
        setIsShowPreviewInfo(false);
        setIsShowConfirmation(false);
        setSendBetTime(null);

        setConfirmationStatus({
            status: null,
            accepted: 0,
            rejected: 0,
            unknown: 0
        });
    };

    const isFlexiEnsabledParaCheck = (line) => {
        if (line.prod == 'HR') {
            const isEnabled = GetChannelPara('FlexiHR') == 1 ? true : false;
            return isEnabled;
        }

        return true;
    };

    const isBetLineEnabledParaCheck = (line) => {
        if (line.betType == undefined || line.betType == null || line.betType == '') return false;

        let isValid = true;
        if ([...HRConfig.ALUP_PAGE, 'CWAALLALUP'].includes(line.betType) || line.betType == 'ALUP') {
            if (!IsAllUpEnabled(line.prod)) {
                isValid = false;
            }

            if (!IsAllUpBetlineEnabled(line)) {
                isValid = false;
            }

            // line.betList.map((bet) => {
            //     if (!isAllUpEnabledWithBetType(bet.betType)) {
            //         isValid = false;
            //         return;
            //     }
            //     if (!IsBetTypeEnabled(bet.betType)) {
            //         isValid = false;
            //         return;
            //     }
            // });
        } else if (!IsBetTypeEnabled(line.betType)) {
            isValid = false;
        }
        /*
        if (line.unitBet > Math(GetChannelPara("MaxBetUnit"))) {
            getAlertShowMode(GetError("1206"));
            return cRetCodeFail;
        }
*/
        return isValid;
    };

    function IsAllUpEnabled(prod) {
        if (prod == 'FB' && !IsBetTypeEnabled('CrossPoolBet')) return false;
        else if (prod == 'HR' && !IsBetTypeEnabled('HorseRaceCrossPool')) return false;
        return true;
    }

    function IsAllUpBetlineEnabled(line) {
        var isSingleAlup = true;
        let betTypes = [...new Set(line.betList.map(i => i.betType))]
        let isCorssPool = betTypes.length > 1
        var firstBetType = line.betList[0].betType;
        firstBetType = TranslateBetType(firstBetType);
        let isET = line.betList.some(i => window.fbConfig['ExtraTimePools'].includes(i.betType))
        if(isET && GetChannelPara('ExtraTime') != 1)   return false
        if(isCorssPool){
            for (var i = 0; i < betTypes.length; i++) {
                if(!GetXPoolAllUpEnabled(betTypes[i])){
                    return false
                }
            }
        } else if (
            line.prod == 'FB' &&
            IsValidFBBetType(firstBetType) &&
            (!IsBetTypeEnabled('Alup' + firstBetType) || !IsBetTypeEnabled(firstBetType))
        ){
            return false;
        }else if (line.prod == 'HR' && (!IsBetTypeEnabled(betTypes[0]) || !IsBetTypeEnabled('CrossPool' + betTypes[0]))){
            return false
        }
        return true;
    }

    function isCwinPool(betType) {
        if (['CWA', 'CWB', 'CWC'].includes(betType)) {
            return true;
        }
        return false;
    }

    function IsValidFBBetType(betType) {
        const hasKey = FBConfig.allupInfo[betType];
        if (hasKey) {
            return true;
        }
        return false;
    }

    function isAllUpEnabledWithBetType(betType) {
        betType = TranslateBetType(betType);
        switch (betType) {
            case 'HAD':
            case 'HDC':
            case 'TTG':
            case 'CRS':
            case 'FCS':
            case 'HFT':
            case 'OOE':
            case 'HIL':
            case 'HLH':
            case 'HLA':
            case 'ELH':
            case 'ELA':
            case 'FLH':
            case 'FLA':
            case 'FGS':
            case 'LGS':
            case 'NGS':
            case 'AGS':
            case 'HHA':
            case 'GPF':
            case 'GPW':
            case 'FHA':
            case 'FTS':
            case 'FHL':
            case 'NTS':
            case 'CHL':
            case 'CHH':
            case 'CHA':
            case 'CFH':
            case 'CFA':
            case 'CEH':
            case 'CEA':
            case 'FCH':
            case 'FHH':
            case 'FHC':
            case 'CHD':
            case 'ECD':
            case 'EHH':
                return IsBetTypeEnabled('Alup' + betType);

            case 'WIN':
            case 'PLA':
            case 'W-P':
            case 'QIN':
            case 'QPL':
            case 'QQP':
            case 'CWA':
            case 'CWB':
            case 'CWC':
            case 'TRI':
                return IsBetTypeEnabled('CrossPool' + betType);
            case 'FCT':
                return GetXPoolAllUpEnabled('FCT');
        }
        return false;
    }

    function GetXPoolAllUpEnabled(betType) {
        betType = TranslateBetType(betType);
        if (RegExp(/^(CWB|CWC)$/).test(betType)) {
            return false;
        } else if (
            // IsBetTypeEnabled(betType) &&
            IsBetTypeEnabled('CrossPool' + betType) &&
            IsBetTypeEnabled('CrossPoolBet')
        ) {
            return true;
        } else if (
            // IsBetTypeEnabled(betType) &&
            IsBetTypeEnabled('CrossPool' + betType) &&
            IsBetTypeEnabled('HorseRaceCrossPool')
        ) {
            return true;
        }
        return false;
    }

    const TranslateBetType = (betType) => {
        var tp = betType;
        switch (betType) {
            case 'EHA':
                tp = 'HAD';
                break;
            case 'EDC':
                tp = 'HDC';
                break;
            case 'EHL':
                tp = 'HIL';
                break;
            case 'ECH':
                tp = 'CHL';
                break;
            case 'ECS':
                tp = 'CRS';
                break;
            case 'ENT':
                tp = 'NTS';
                break;
            case 'ETG':
                tp = 'TTG';
                break;
        }

        return tp;
    };

    /**
     * @param {String} id bet line id
     * */
    const removeBetLinesItem = (id) => {
        const newData = betBaskets[currentBasket].filter((item) => item.id !== id);
        const removeData = betBaskets[currentBasket].find((item) => item.id === id);
        const deleteBetSlipAdobeEventData = getDeleteBetSlipAdobeEventData([removeData], t);
        if (deleteBetSlipAdobeEventData) {
            sendAdobeEvent(deleteBetSlipAdobeEventData);
        }
        updateCurrentBasket(newData);
        //setBetLines(newData)
    };

    /**
     * @param {object} itemData  oldBetline --> itemData
     * */
    const updateBetLinespData = (itemData) => {
        const newData = betBaskets[currentBasket].map((item) => {
            if (itemData.id === item.id) {
                return itemData;
            }
            return item;
        });
        updateCurrentBasket(newData);
        //setBetLines(newData)
    };

    const computePanelAllupFunc = (betlines) => {
        const curBetLine = betlines[currentBasket];
        let curPanelAllupObj = { ...panelAllupRef.current[currentBasket] };
        if(curBetLine.length === 0 || curPanelAllupObj.allupCheckList?.length === 0){
            return ;
        }
        let allupInitObj = {
            name: currentBasket,
            allupType: '',
            subTypeList: [],
            allupMaxLeg: 8,
            allupGroup: 1,
            uniqueMatchIdList: [],
            allupCheckList: []
        };
        let stopSellBet = curBetLine.filter(item => {
            const { betObj } = item;
            return betObj?.isStopSell;
        })
        if (stopSellBet.length > 0) {
            if (curPanelAllupObj.allupType?.length === 0) {
                curPanelAllupObj.allupType = curPanelAllupObj.allupCheckList[0].prod;
            }
            stopSellBet.map(item => {
                const { betObj } = item;
                curPanelAllupObj.allupCheckList = curPanelAllupObj.allupCheckList.filter((item) => {
                    return item.id !== betObj.id;
                })
                if (curPanelAllupObj.allupCheckList.length === 0) {
                    curPanelAllupObj = {
                        ...allupInitObj
                    };
                } else {
                    curPanelAllupObj.uniqueMatchIdList = getUniqueMatchIdFn(
                        curPanelAllupObj.allupCheckList,
                        curPanelAllupObj.allupGroup === 2 && curPanelAllupObj.allupType === 'FB' ? 'raceno' : 'matchId'
                    );
                }
            })
            panelAllupRef.current[currentBasket] = curPanelAllupObj;
            setPanelAllupArr([...panelAllupRef.current]);
        }
    }

    const panelAllupCheckFn = (comb) => {
        const FBconfig = GetFootballConfig();
        const { TournamentAllupPools, AllupEnabledPools, MixAllup6LegPools } = FBconfig;
        const HRconfig = GetRaceConfig();
        const { AllupPools, Allup3LegPools } = HRconfig;
        const { betObj } = comb;
        let curPanelAllupObj = { ...panelAllupArr[currentBasket] };
        if (curPanelAllupObj.allupType.length === 0) {
            curPanelAllupObj.allupType = comb.prod;
        }
        let allupInitObj = {
            name: currentBasket,
            allupType: '',
            subTypeList: [],
            allupMaxLeg: 8,
            allupGroup: 1,
            uniqueMatchIdList: [],
            allupCheckList: []
        };

        if (curPanelAllupObj.allupType === 'FB') {
            if (curPanelAllupObj.subTypeList.length === 0) {
                if (TournamentAllupPools.includes(betObj.betType)) {
                    curPanelAllupObj.subTypeList = TournamentAllupPools;
                    curPanelAllupObj.allupGroup = 2;
                } else {
                    curPanelAllupObj.subTypeList = [...AllupEnabledPools];
                    curPanelAllupObj.allupGroup = 1;
                }
            }
            const newObj = {
                ...betObj,
                betType: betObj.betType,
                id: betObj.id,
                matchId: betObj.matchId,
                raceno: betObj?.combs?.[0]?.currentPool?.instNo
            };
            if (curPanelAllupObj.allupCheckList.length === 0) {
                curPanelAllupObj.allupCheckList.push(newObj);
            } else {
                let isFindId = curPanelAllupObj.allupCheckList.find((item) => {
                    return item.id === betObj.id;
                });
                if (isFindId) {
                    curPanelAllupObj.allupCheckList = curPanelAllupObj.allupCheckList.filter((item) => {
                        return item.id !== betObj.id;
                    });
                    if (curPanelAllupObj.allupCheckList.length === 0) {
                        curPanelAllupObj = {
                            ...allupInitObj
                        };
                    }
                } else {
                    curPanelAllupObj.allupCheckList.push(newObj);
                }
            }
            curPanelAllupObj.uniqueMatchIdList = [];
            if (curPanelAllupObj.allupCheckList.length > 0) {
                curPanelAllupObj.allupMaxLeg = curPanelAllupObj.allupCheckList.find((item) => {
                    return MixAllup6LegPools.includes(item.betType);
                })
                    ? 6
                    : 8;
                curPanelAllupObj.uniqueMatchIdList = getUniqueMatchIdFn(
                    curPanelAllupObj.allupCheckList,
                    curPanelAllupObj.allupGroup === 2 ? 'raceno' : 'matchId'
                );
            }
        }
        if (curPanelAllupObj.allupType === 'HR') {
            if (curPanelAllupObj.subTypeList.length === 0) {
                curPanelAllupObj.subTypeList = AllupPools;
                curPanelAllupObj.allupMaxLeg = 6;
            }
            const newObj = {
                ...betObj,
                betType: betObj.betType,
                id: betObj.id,
                matchId: betObj.meetingId,
                raceno: betObj.raceno
            };
            if (curPanelAllupObj.allupCheckList.length === 0) {
                curPanelAllupObj.allupCheckList.push(newObj);
            } else {
                let isFindId = curPanelAllupObj.allupCheckList.find((item) => {
                    return item.raceno === betObj.raceno;
                });
                if (isFindId) {
                    curPanelAllupObj.allupCheckList = curPanelAllupObj.allupCheckList.filter((item) => {
                        return item.raceno !== betObj.raceno;
                    });
                    if (curPanelAllupObj.allupCheckList.length === 0) {
                        curPanelAllupObj = {
                            ...allupInitObj
                        };
                    }
                } else {
                    curPanelAllupObj.allupCheckList.push(newObj);
                }
            }
            curPanelAllupObj.uniqueMatchIdList = [];
            if (curPanelAllupObj.allupCheckList.length > 0) {
                curPanelAllupObj.allupMaxLeg = curPanelAllupObj.allupCheckList.find((item) => {
                    return Allup3LegPools.includes(item.betType);
                })
                    ? 3
                    : 6;
                curPanelAllupObj.uniqueMatchIdList = getUniqueMatchIdFn(curPanelAllupObj.allupCheckList, 'raceno');
            }
        }
        const panelAllup = [...panelAllupArr];
        panelAllup[currentBasket] = curPanelAllupObj;
        setPanelAllupArr(panelAllup);
    };

    const getUniqueMatchIdFn = (arr, key = 'matchId') => {
        let obj = {};
        let newArr = [];
        arr.forEach((item) => {
            let newId = item[key];
            if (!obj[newId]) {
                newArr.push(newId);
                obj[newId] = true;
            }
        });
        return newArr;
    };

    const resetPanelAllupFn = (type = '') => {
        let newpanelAllupArr = [...panelAllupArr];
        // let initAllupArr = [];
        if (type === 'all') {
            newpanelAllupArr = [];
            speedbetBasket.map((item) => {
                let obj = {
                    name: item,
                    allupType: '',
                    subTypeList: [],
                    allupMaxLeg: 8,
                    allupGroup: 1,
                    uniqueMatchIdList: [],
                    allupCheckList: []
                };
                newpanelAllupArr.push(obj);
            });
        } else {
            newpanelAllupArr[currentBasket] = {
                name: currentBasket,
                allupType: '',
                subTypeList: [],
                allupMaxLeg: 8,
                allupGroup: 1,
                uniqueMatchIdList: [],
                allupCheckList: []
            };
        }
        setPanelAllupArr([...newpanelAllupArr]);
    };

    const updateBetTotal = (betLines, isPreview) => {
        let totalBet = 0;
        let totalAmount = 0;
        betBaskets[currentBasket]?.map((item) => {
            
            if ( item.betObj.isStopSell){
                // filter cannot Selling
            } else if (item.prod === 'FB' && (
                isPreview && checkPreviewBetOddsUpdated(item) && !item.isAcceptance
                || isPreview && item.onlyDisplayOnBetSlip
            )) {
                return;
            }else if (item.prod === 'FB' && item.betObj.betType === 'ALUP') {
                
                totalBet = totalBet + item.betObj.noOfComb;
                totalAmount = totalAmount + item.betObj.noOfComb * item.unitBet;
            } else if (item.prod === 'HR') {
                totalBet = totalBet + item.betObj.noOfBets;
                if (item.betObj.isFlexi && item.betObj.betTotal) {
                    totalAmount = totalAmount + parseInt(item.betObj.betTotal);
                } else {
                    totalAmount = totalAmount + item.betObj.noOfBets * item.unitBet;
                }
            } else {
                const multidraw = item.betObj.multidraw ? item.betObj.multidraw : 1;
                totalBet = totalBet + item.betObj.noOfBets * multidraw;
                totalAmount = totalAmount + item.betObj.noOfBets * item.unitBet * multidraw;
            }
        });
        setBetTotal({ totalBet, totalAmount });
        return { totalBet, totalAmount };
    };

    const getBetTotal = () => {
        return betTotal;
    };

    const getNumberOfBetlines = (isPreview) => {
        const currentBetLines = betBaskets[currentBasket];
        if (!Array.isArray(currentBetLines)) return 0;
        return currentBetLines.reduce((count, betline) => {
            if (
                betline.betObj.isStopSell ||
                (betline.prod === 'FB' &&
                    (
                        (isPreview && checkPreviewBetOddsUpdated(betline) && !betline.isAcceptance) ||
                        (isPreview && betline.onlyDisplayOnBetSlip)
                    )
                )
            ) {
                return count;
            }
            return count + 1;
        }, 0);
    };

    const getNotPlacedBetLineReason = (notPlacedBetLine) => {
        if (notPlacedBetLine.betObj.isStopSell && notPlacedBetLine.isStopSellOnPreview) {
            if (notPlacedBetLine.betObj.sellStatus == 'CLOSED') {
                return 'LB_BS_CLOSED_REASON';
            }
            return 'LB_BS_SUSPENDED_REASON';
        }
        return 'LB_BS_NOT_PLACED_REASON';
    };

    const sendBetRequest = async (access_token, seqNo, isRetry = false, isLB = false, isNew = true, setErrorMessage = () => {}) => {
        // send request
        if (globalContext.globalState.isSendingBet || window.SettlementInProgress) return;
        globalContext.updateGlobalState({ isSendingBet: true });

        const bets = IsPassBetlinesValidFn(betBaskets[currentBasket], {validType:'sendbet'}).passBets;
        let betLines = []
        let dimBetLines = []
        let notPlacedBetLines = [];
        let onlyDisplayOnBetSlips = [];
        for (let i = 0; i < betBaskets[currentBasket].length; i++) {
            const element = betBaskets[currentBasket][i];
            if (element.betObj.isStopSell){
                if (
                    window.globalConfig.BS_PREVIEW_DATA_REFRESH
                    && element.isStopSellOnPreview
                ) {
                    notPlacedBetLines.push(element);
                } else {
                    dimBetLines.push(element)
                }
                continue;
            }

            if (
                window.globalConfig.BS_PREVIEW_DATA_REFRESH
                && element.prod === 'FB'
                && checkPreviewBetOddsUpdated(element)
                && !element.isAcceptance
            ) {
                notPlacedBetLines.push(element);
                continue;
            }

            if (element.prod === 'FB' && element.onlyDisplayOnBetSlip) {
                onlyDisplayOnBetSlips.push(element);
                continue;
            }

            betLines.push(
                {
                    ...element,
                    betLineStr: bets[i]?.betline
                }
            )
        }
        notPlacedBetLines = notPlacedBetLines.map(notPlacedBetItem => ({
            ...notPlacedBetItem,
            isNotPlaced: true,
            reason: getNotPlacedBetLineReason(notPlacedBetItem),
            resultAmount: 0,
        }));
        const pushBets = IsPassBetlinesValidFn(betBaskets[currentBasket], {validType:'sendbet',pushFilter:true}).passBets;

        const sessionData = await getSessionId_IB(false);
        let newConfirmationStatus = null;

        if (sessionData?.sessionId) {
            let sendBetOutput = await sendBetApi_IB({ accessToken: access_token, sessionData, bets: pushBets, language: i18n.language, seqNo, isRetry, isLB, isNew });
            setErrorMessage?.(sendBetOutput?.betResult?.[0]?.resultMsg)
            if (sendBetOutput?.delay_time_in_seconds) {
                // inplay
                return sendBetOutput;
            }
            if (sendBetOutput?.sendbet_error && sendBetOutput?.sendbet_error.indexOf('159') >= 0 && !isRetry) {
                // retry
                return sendBetOutput;
            }
            if (sendBetOutput?.sendbet_status == '-2') {
                globalContext.updateGlobalState({ isSendingBet: false });
                return sendBetOutput;
            }
            if (sendBetOutput) {
                setSendBetTime(sendBetOutput.betTime || t('LB_BS_LOGIN_NO_TIME'));
                let acceptedCount = 0;
                let rejectedCount = 0;
                let betResult = sendBetOutput?.betResult;
                let isResendBet = false;
                let x = 0;
                betLines = betLines.map((item) => {
                    if(item.betObj.isStopSell)return item
                    const resultData = betResult ? betResult[x] : null; //?.find((i) => i.translatorBetline === item.betLineStr);
                    let resultMsg = resultData?.resultMsg;
                    let resultMsgChi = resultData?.resultMsgChi;
                    x++;
                    const resultBetInfo = resultData?.betInfo;
                    let showResendControlBtn = false;
                    item.isCounterOffer = false;
                    item.counterOfferData = undefined;

                    if (resultData?.result == 0) {
                        acceptedCount += 1;
                        let xtremePushData = getXtremePushData(item, resultData, t)
                        if(xtremePushData && (!resultBetInfo?.oddsFlag || resultBetInfo?.oddsFlag == '0')){
                            xtremePush('event','bet_sent_success_sports',xtremePushData)
                        }
                        if (resultBetInfo?.oddsFlag != null) {
                            if (resultBetInfo?.oddsFlag == '0') {
                                //auto acceptance
                                item.isAutoAcceptance = true;
                                updateBetLineOdds(item, resultBetInfo);
                            } else if (resultBetInfo?.oddsFlag == '3') {
                                // counter offer
                                rejectedCount += 1;
                                acceptedCount -= 1;
                                isResendBet = true;
                                showResendControlBtn = true;
                                item.isCounterOffer = true;
                                item.counterOfferData = {
                                    counterOfferKey: resultBetInfo.counterOfferKey,
                                    systemCounterOfferCount: resultBetInfo.systemCounterOfferCount
                                };
                                if (resultBetInfo?.counterOfferType == '1') {
                                    item.counterOfferOddsChange = true;
                                    item.counterOfferAmountChange = false;
                                    resultMsg = t('LB_BS_COUNTER_ODDS', { lng: 'en' });
                                    resultMsgChi = t('LB_BS_COUNTER_ODDS', { lng: 'ch' });
                                }
                                if (resultBetInfo?.counterOfferType == '2') {
                                    item.counterOfferOddsChange = false;
                                    item.counterOfferAmountChange = true;
                                    resultMsg = t('LB_BS_COUNTER_AMOUNT', { lng: 'en' });
                                    resultMsgChi = t('LB_BS_COUNTER_AMOUNT', { lng: 'ch' });
                                }
                                if (resultBetInfo?.counterOfferType == '3') {
                                    item.counterOfferOddsChange = true;
                                    item.counterOfferAmountChange = true;
                                    resultMsg = t('LB_BS_COUNTER_ODDS_AMOUNT', { lng: 'en' });
                                    resultMsgChi = t('LB_BS_COUNTER_ODDS_AMOUNT', { lng: 'ch' });
                                }
                                updateBetLineOdds(item, resultBetInfo);
                            }
                        }
                    } else if (resultData?.result > 0 || resultData?.result < 0) {
                        rejectedCount += 1;
                    }
                    betResult = betResult?.map((item) => {
                        /* if (item?.translatorBetline === resultData?.translatorBetline) {
                            return {};
                        }
                        */
                        return item;
                    });
                    return {
                        ...item,
                        resultCode: resultData?.result,
                        txNo: resultData?.txNo,
                        showResendControlBtn,
                        resultMsg: resultMsg,
                        resultMsgChi: resultMsgChi,
                        resultAmount: resultData?.totalInvAmt || 0,
                        flexiUnitBet: resultData?.flexiUnitBet
                    };
                });

                if (acceptedCount == 0 && rejectedCount == 0) {
                    newConfirmationStatus = {
                        ...confirmationStatus,
                        status: 'unknown',
                        unknown: betLines.length
                    };
                    setConfirmationStatus(newConfirmationStatus);
                    setBalance('---');
                } else {
                    let status = '';
                    if (acceptedCount === betLines.length) {
                        status = 'accepted';
                        if(notPlacedBetLines.length === 0 ) {
                            sessionStorage.setItem('confirmationStatus', 'accepted')
                        }
                    } else if (rejectedCount === betLines.length) {
                        status = 'rejected';
                    } else {
                        status = 'unknown';
                        setBalance('---');
                    }
                    newConfirmationStatus = {
                        status,
                        unknown: betLines.length - (acceptedCount + rejectedCount),
                        accepted: acceptedCount,
                        rejected: rejectedCount,
                        isResendBet
                    };
                    setConfirmationStatus(newConfirmationStatus);
                }
            } else {
                newConfirmationStatus = {
                    ...confirmationStatus,
                    status: 'unknown',
                    unknown: betLines.length
                };
                setConfirmationStatus(newConfirmationStatus);
                setBalance('---');
            }

            // set balance
            const newbalance = sendBetOutput?.newBalance;
            if (newbalance || newbalance == 0) {
                const formatted_newbalance = (+newbalance).toLocaleString(undefined, { minimumFractionDigits: 2 });
                setBalance(formatted_newbalance);
                sessionStorage.setItem('balance', newbalance);
            }
        } else {
            newConfirmationStatus = {
                ...confirmationStatus,
                status: 'unknown',
                unknown: betLines.length
            }
            setConfirmationStatus(newConfirmationStatus);
            setBalance('---');
        }
        const displayBetLines = [...betLines, ...notPlacedBetLines]
        displayBetLines.sort((a, b) => {
            let aOrderScore = 1;
            let bOrderScore = 1;
            if (a.resultCode === 0 && a.isCounterOffer) {
                // counter
                aOrderScore = 5;
            } else if (a.resultCode === 1) {
                // reject
                aOrderScore = 4;
            } else if (a.isNotPlaced) {
                // not placed
                aOrderScore = 2;
            } else if (!a?.resultCode && a.resultCode !== 0) {
                // unknown
                aOrderScore = 3;
            }

            if (b.resultCode === 0 && b.isCounterOffer) {
                // counter
                bOrderScore = 5;
            } else if (b.resultCode === 1) {
                // reject
                bOrderScore = 4;
            } else if (b.isNotPlaced) {
                // not placed
                bOrderScore = 2;
            } else if (!b?.resultCode && b.resultCode !== 0) {
                // unknown
                bOrderScore = 3;
            }
            return bOrderScore - aOrderScore;
        });
        if(isLogonHigh()){
            // duplicate login or idle timeout checking
            saveBetLinesToCurrentSessionRecords(betLines);
            updateCurrentBasket([...displayBetLines, ...onlyDisplayOnBetSlips, ...dimBetLines]);
            setIsShowConfirmation(true);

            const transactionBetResultAdobeEventData = getTransactionBetResultAdobeEventData(betLines, newConfirmationStatus, t);
            if (transactionBetResultAdobeEventData) {
                sendAdobeEvent(transactionBetResultAdobeEventData)
            }
        } else {
            updateCurrentBasket([]);
            setIsShowConfirmation(false);
        }
        globalContext.updateGlobalState({ isSendingBet: false });
    };

    const betDoneFn = () => {
        setIsShowPreviewInfo(false);
        setIsShowConfirmation(false);
        setSendBetTime(null);
        setConfirmationStatus({
            status: null,
            accepted: 0,
            rejected: 0,
            unknown: 0
        });
        clearCurrentBasket();
    };

    const resendBetDoneFn = (currentBasketData) => {
        setIsShowPreviewInfo(true);
        setIsShowConfirmation(false);
        setSendBetTime(null);

        setConfirmationStatus({
            status: null,
            accepted: 0,
            rejected: 0,
            unknown: 0
        });
        clearCurrentBasket({isResend: true, currentBasketData});
    };

    const disabledResendBtn = () => {
        const resendBetLines = betBaskets[currentBasket]?.find((i) => i.isCounterOffer);
        return !resendBetLines;
    };

    return {
        betBaskets,
        setBetBaskets,
        addToBetSlip,
        removeBetLinesItem,
        updateBetLinespData,
        panelAllupObj: panelAllupArr[currentBasket],
        resetPanelAllupFn,
        panelAllupCheckFn,
        computePanelAllupFunc,
        isShowPreviewInfo,
        setIsShowPreviewInfo,
        isShowFTInplayDialog,
        setIsShowFTInplayDialog,
        clearBetSlip,
        updateBetSlipOnUserStateChangeRef,
        updateBetTotal,
        getBetTotal,
        getNumberOfBetlines,
        isShowError,
        setIsShowError,
        panelAllupData,
        setPanelAllupData,
        currentBasket,
        betLines: betBaskets[currentBasket],
        setCurrentBasket,
        clearCurrentBasket,
        sendBetRequest,
        isShowConfirmation,
        setIsShowConfirmation,
        betDoneFn,
        sendBetTime,
        confirmationStatus,
        balance,
        setBalance,
        disabledResendBtn: disabledResendBtn(),
        updateResendBetLine,
        resendBetDoneFn,
        isSpeedbet,
        setIsSpeedbet,
        sendBetAPILoading: globalContext.globalState.isSendingBet,
        betBaskets_0,
        firstTimeFromJCRWRedirect,
        GetXPoolAllUpEnabled,
        TranslateBetType,
        disablePreviewConfirm,
        setDisablePreviewConfirm
    };
};

const updateBetLineOdds = (betLine, resultBetInfo) => {
    const betObj = betLine.betObj;
    const newInvestment = resultBetInfo?.newInvestment;
    const newAmount = newInvestment?.proposedAmount;
    if (resultBetInfo?.counterOfferType == '2' || resultBetInfo?.counterOfferType == '3') {
        // amount changed
        betLine.oldUnitBet = betLine.unitBet;
        betLine.unitBet = newAmount?.replace('$', '');
        betLine.counterOfferAmountChange = true;
    }
    if (betObj?.betType != 'ALUP') {
        //
        betLine.betObj.combs = betObj.combs.map((comb) => {
            const currNewOdds = newInvestment?.newOdds?.find(
                (oddsObj) =>
                    comb.poolId == oddsObj.poolId &&
                    comb.combId == oddsObj.combId &&
                    comb.lineId == oddsObj.lineId
            );
            if (currNewOdds) {
                const oldOddsVal = comb.oddsVal || comb.currentOdds; // football || JKC&TNC
                return {
                    ...comb,
                    oldOddsVal,
                    oddsVal: currNewOdds.oddsVal, // football
                    currentOdds: currNewOdds.oddsVal // JKC&TNC
                };
            }
            return comb;
        });
    } else {
        // All Up
        betLine.betObj.betList = betLine.betObj.betList.map((item, index) => {
            item.combs = item.combs.map((comb) => {
                const currNewOdds = newInvestment?.newOdds?.find(
                    (oddsObj) =>
                        comb.poolId == oddsObj.poolId && comb.combId == oddsObj.combId && comb.lineId == oddsObj.lineId
                );
                if (currNewOdds) {
                    const oldOddsVal = comb.oddsVal || comb.currentOdds; // football || JKC&TNC
                    return {
                        ...comb,
                        oldOddsVal,
                        oddsVal: currNewOdds.oddsVal, // football
                        currentOdds: currNewOdds.oddsVal // JKC&TNC
                    };
                }
                return comb;
            });
            return item;
        });
    }
};

export const AddM6SlipFunc = (data, context, getAlertShowMode) => {
    let m6Arr = [...data];
    const betLineList = [];
    const initDefaultUnitBet = sessionStorage.getItem('Mk6DefaultUnitBetAmount')
        ? Number(sessionStorage.getItem('Mk6DefaultUnitBetAmount'))
        : 10;

    m6Arr.map((item, index) => {
        const id = new Date().getTime() + '' + index;
        let betLineObj = {
            ...item,
            multidraw: item.multidraw ? item.multidraw - 0 : item.multDraw ? item.multDraw - 0 : 1,
            chance: item.chance ? item.chance - 0 : 1,
            unitBet: item.unitBet ? item.unitBet - 0 : initDefaultUnitBet,
            bankerList: item.bankerList || [],
            prod: 'M6',
            betType: 'MK6',
            pageName: context.pageName,
            nextDraw: context.nextDraw,
            id,
            noOfBets: item.chance ? item.chance - 0 : 1
        };
        if (item.numList.length > 0) {
            if (
                betLineObj?.nextDraw?.snowballCode?.length == 0 ||
                (betLineObj?.nextDraw?.snowballCode?.length > 0 && sessionStorage.getItem('MK6SBDraw') == '1')
            ) {
                betLineList.push(betLineObj);
            }
            if((betLineObj?.nextDraw?.snowballCode?.length > 0 && sessionStorage.getItem('MK6SBDraw') != '1')){
                getAlertShowMode(context.translation('LB_BS_ADDTOSLIP_ERR_NOT_AVAILABLE'));
            }
        }
    });
    return betLineList;
};